<div ng-controller="emailGroupsManagementController as ctrl" class="modal-view email-groups-management">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>